import React from "react";
import { Button, Row, Col, Badge } from "react-bootstrap";
import HeaderMobile from "../layouts/HeaderMobile";

export default function ApiService() {
  return (
    <React.Fragment>
      <HeaderMobile />
      <div className="main-pricing p-4 p-lg-5">
        <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
          <span className="text-uppercase text-primary fw-semibold small">API Service</span>
          <span className="text-secondary small">Base URL: /api/v1</span>
        </div>
        <h1 className="pricing-title mb-2">구루위스퍼 API로 금융 데이터를 제품에 바로 연결하세요.</h1>
        <p className="pricing-text mb-4">
          회사 정보, 공시/뉴스, 트렌드 데이터를 안정적으로 제공합니다. API 서비스는 월 19,900원으로 시작하며,
          사용량 확장과 전용 지원이 필요한 경우 별도 협의가 가능합니다.
        </p>

        <div className="d-flex flex-wrap gap-2 mb-3">
          <Button variant="primary" className="fw-medium">API 키 신청</Button>
          <Button variant="" className="btn-white fw-medium" href="mailto:junsung.lim@guruwhisper.com">영업/제휴 문의</Button>
        </div>

        <div className="api-pills d-flex flex-wrap gap-2 mb-4">
          <Badge bg="light" text="dark">API Key 인증</Badge>
          <Badge bg="light" text="dark">JSON 응답</Badge>
          <Badge bg="light" text="dark">SLA 옵션</Badge>
        </div>

        <div className="api-section mb-4">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
            <div>
              <h5 className="fw-bold mb-1">대표 API</h5>
              <p className="pricing-text mb-0">자주 쓰는 엔드포인트만 간추렸습니다.</p>
            </div>
          </div>
          <Row className="g-3">
            <Col md={6} xl={4}>
              <div className="api-card">
                <div className="api-card-top">
                  <span className="api-title">Company Info</span>
                  <span className="api-tag">Company</span>
                </div>
                <code className="api-endpoint">/api/v1/companyinfo</code>
                <p className="api-desc mb-0">회사/티커 검색 및 메타 정보 조회</p>
              </div>
            </Col>
            <Col md={6} xl={4}>
              <div className="api-card">
                <div className="api-card-top">
                  <span className="api-title">Company News</span>
                  <span className="api-tag">News</span>
                </div>
                <code className="api-endpoint">/api/v1/companynews</code>
                <p className="api-desc mb-0">기업 뉴스/공시 요약 데이터</p>
              </div>
            </Col>
            <Col md={6} xl={4}>
              <div className="api-card">
                <div className="api-card-top">
                  <span className="api-title">Curation</span>
                  <span className="api-tag">Trend</span>
                </div>
                <code className="api-endpoint">/api/v1/curation</code>
                <p className="api-desc mb-0">투자 트렌드/큐레이션 리스트</p>
              </div>
            </Col>
            <Col md={6} xl={4}>
              <div className="api-card">
                <div className="api-card-top">
                  <span className="api-title">Form 4</span>
                  <span className="api-tag">Insider</span>
                </div>
                <code className="api-endpoint">/api/v1/form4</code>
                <p className="api-desc mb-0">내부자 거래 공시 데이터</p>
              </div>
            </Col>
            <Col md={6} xl={4}>
              <div className="api-card">
                <div className="api-card-top">
                  <span className="api-title">Guru History</span>
                  <span className="api-tag">Guru</span>
                </div>
                <code className="api-endpoint">/api/v1/guru_history_by_ticker</code>
                <p className="api-desc mb-0">투자 대가 포지션 히스토리</p>
              </div>
            </Col>
            <Col md={6} xl={4}>
              <div className="api-card">
                <div className="api-card-top">
                  <span className="api-title">FS Extract</span>
                  <span className="api-tag">Finance</span>
                </div>
                <code className="api-endpoint">/api/v1/company-fs-extract</code>
                <p className="api-desc mb-0">핵심 재무 지표 요약</p>
              </div>
            </Col>
          </Row>
        </div>

        <div className="api-pricing">
          <div className="api-pricing-header">
            <div>
              <h5 className="fw-bold mb-1">요금제</h5>
              <p className="pricing-text mb-0">월 19,900원부터 시작하는 간단한 가격 구조입니다.</p>
            </div>
          </div>
          <Row className="g-3">
            <Col md={6} xl={4}>
              <div className="api-plan">
                <div className="api-plan-top">
                  <div>
                    <div className="api-plan-name">Sandbox</div>
                    <div className="api-plan-desc">테스트/개발용</div>
                  </div>
                  <Badge bg="light" text="dark">무료</Badge>
                </div>
                <div className="api-plan-price">
                  ₩0 <small>/월</small>
                </div>
                <ul className="api-plan-list">
                  <li>월 10,000 요청</li>
                  <li>분당 60 요청</li>
                  <li>표준 응답 우선순위</li>
                  <li>커뮤니티 지원</li>
                </ul>
                <Button variant="primary" className="w-100">Sandbox 시작</Button>
              </div>
            </Col>
            <Col md={6} xl={4}>
              <div className="api-plan api-plan--featured">
                <div className="api-plan-top">
                  <div>
                    <div className="api-plan-name">Standard</div>
                    <div className="api-plan-desc">상용 배포/운영</div>
                  </div>
                  <Badge bg="primary">추천</Badge>
                </div>
                <div className="api-plan-price">
                  ₩19,900 <small>/월</small>
                </div>
                <ul className="api-plan-list">
                  <li>월 200,000 요청</li>
                  <li>분당 600 요청</li>
                  <li>우선 응답 처리</li>
                  <li>이메일 지원 + SLA</li>
                </ul>
                <Button variant="primary" className="w-100">Standard 신청</Button>
              </div>
            </Col>
            <Col md={6} xl={4}>
              <div className="api-plan">
                <div className="api-plan-top">
                  <div>
                    <div className="api-plan-name">Enterprise</div>
                    <div className="api-plan-desc">대량 트래픽/전담 지원</div>
                  </div>
                  <Badge bg="light" text="dark">맞춤</Badge>
                </div>
                <div className="api-plan-price">
                  맞춤 <small>/월</small>
                </div>
                <ul className="api-plan-list">
                  <li>요청량 맞춤 설계</li>
                  <li>전용 인프라/캐시</li>
                  <li>전담 지원 &amp; SLA</li>
                  <li>커스텀 데이터 연동</li>
                </ul>
                <Button variant="primary" className="w-100">Enterprise 문의</Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}
